import React from "react";

function Toggle({className,onClick }){
  return (
    <div className={`${className}`}>
      <label className="relative inline-flex items-center cursor-pointer">
        <input type="checkbox" value="" className="sr-only peer"onClick={onClick} />
        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-200 peer-checked:bg-blue-300"></div>
        <span className="ml-3 text-xs font-bold text-black dark:text-gray-300">이로치</span>
      </label>
    </div>
  );
}

export default Toggle;